import type { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_DIVIDER_SEVERITY = {
  Default: "default",
  Soft: "soft",
  Accent: "accent",
} as const;

export type DSDividerSeverity = ObjectValues<typeof DS_DIVIDER_SEVERITY>;
